import React, { useEffect, useRef, useState } from 'react';
import './ReportView.scss';
import GlobalParams from '../../helpers/GlobalParams';
import { Button, DataGrid, Popup, Template } from 'devextreme-react';
import ApiPostHelper from '../../helpers/ApiPostHelper';
import LoadPanel from 'devextreme-react/load-panel';
import { Column } from 'devextreme-react/cjs/data-grid';
import notify from 'devextreme/ui/notify';

const ReportView = ({ url, onClosePopup }) => {

  const [isLoading, setIsLoading] = useState(true);
  const [isDone, setIsDone] = useState(false);

  const containerRef = useRef(null);

  const renderPdfViewer = (base64PDF) => {
    const container = containerRef.current;

    if (container) {
      const viewerObject = document.createElement('object');
      viewerObject.type = 'application/pdf';
      viewerObject.style.width = '100%';
      viewerObject.style.height = '800px';
      viewerObject.data = 'data:application/pdf;base64,' + base64PDF;

      container.appendChild(viewerObject);
    }
  };

  const fetchData = async () => {
    try {

      const result = await ApiPostHelper.postData(
        GlobalParams.LoginApiUrlPrefix + 'getReportsLaravel',
        GlobalParams.bearerToken,
        JSON.stringify({
          url_path: url,
        })
      );

      /*if (!result.success) {
        setIsLoading(false);
        setIsDone(true);
        console.log("report has failed brother");
        return;
        //notify("Server Error", 'error', 5000);
      }*/

      console.log(result);
      // Delay setting isLoading to false until after renderPdfViewer completes
      renderPdfViewer(result);
    } catch (error) {
      // Handle error, e.g., show an error message
      console.log(error);
    } finally {
      // Set isLoading to false after renderPdfViewer completes
      setIsLoading(false);
      setIsDone(true);
    }
  };


  // useEffect to listen for changes in isLoading and trigger renderPdfViewer
  useEffect(() => {
    console.log(isDone);
    if (!isLoading) {
      // Call renderPdfViewer once isLoading becomes false
      renderPdfViewer();
    } else {
      if (!isDone) {
        console.log(url);
        //containerRef.current.innerHTML = '';
        fetchData();
      }
    }
  }, [isLoading,isDone]);

  useEffect(() => {
    // Cleanup function to reset states and clear container content when component unmounts or when the popup is hidden
    return () => {
      // Clear the content of the container
      if (containerRef.current) {
        containerRef.current.innerHTML = '';
      }
      // Reset loading and done states
      setIsLoading(true);
      setIsDone(false);
    };
  }, [onClosePopup]);
  

  return (
    <div>
      <LoadPanel visible={isLoading} />
      <div ref={containerRef} id="pdf-container"></div>
    </div>
  );
};

export default ReportView;
